import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { FadeUp, LineReveal } from "@/components/site/Reveal";
import { CONTACT, IMG } from "@/lib/content";

export const FounderNote = () => {
  const mark = CONTACT.people[0];
  return (
    <section data-testid="founder-note" className="bg-[var(--concrete)] text-[var(--ink)]">
      <div className="mx-auto max-w-[1440px] px-5 lg:px-10 py-24 lg:py-36 grid lg:grid-cols-12 gap-12 items-center">
        <FadeUp className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative aspect-[4/5] overflow-hidden rounded-2xl clip-ticket">
            <img src={IMG.washSpray} alt="Car being foam washed" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-[var(--navy)]/20" />
          </div>
        </FadeUp>
        <div className="lg:col-span-7 order-1 lg:order-2">
          <p className="eyebrow eyebrow-dark">A note from Mark</p>
          <LineReveal onView lines={["We're a family", "business — just", "like you."]} className="mt-5 font-display font-black uppercase leading-[0.88] text-5xl sm:text-6xl lg:text-7xl" />
          <FadeUp>
            <div className="mt-8 space-y-5 text-base sm:text-lg text-slate-700 leading-relaxed max-w-2xl">
              <p>We've worked for business owners from Kyneton to Kuranda to Kununurra since 2013. So let's get together soon for a coffee — either at your carwash or over a Zoom call — and have a clear, honest talk about what's actually possible for your operation.</p>
              <p>I'm always around and can talk any time, any day of the week — to look at what's possible to make you seriously more profit every month, a much higher business valuation at no extra capital cost, and the peace of mind of ignoring next month's power bill increases.</p>
            </div>
            <div className="mt-10 flex flex-wrap items-center gap-6">
              <div>
                <p className="font-display font-black uppercase text-3xl">{mark.name}</p>
                <p className="text-slate-600">{mark.role}</p>
              </div>
              <a href={mark.href} data-testid="founder-call-mark" className="inline-flex items-center gap-2 rounded-full bg-[var(--ink)] text-white px-6 py-3 font-display font-bold uppercase tracking-wider transition-colors hover:bg-[#0057c2]">
                <Phone size={16} /> {mark.phone}
              </a>
              <Link to="/about" data-testid="founder-about-link" className="font-display font-bold uppercase tracking-wider text-[#0057c2] underline underline-offset-4 decoration-2 decoration-[var(--sun)]">Meet the team</Link>
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
};
